import { Component, Input } from '@angular/core'
/**
 * nfLoader sizes
 */
export type size = 'lg' | 'md' | 'sm'
/**
 * @internal
 * This component that hold the template for the spinner.
 *
 *SpinnerDirective should be used to get a spinner, not this component.
 *
 */
@Component({
  selector: 'hs-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss'],
})
export class CustomLoaderComponent {
  @Input()
  size: size = 'md'
  @Input()
  showText: boolean | null = false
  @Input()
  loading: boolean | null = false
  @Input()
  label: string | null = 'Loading...'

  @Input()
  errorLabel: string | undefined
}
